$( document ).ready(function() {
  $('.template-page .section-header h2, #shopify-section-template--14532439605382__rich-text h2').replaceWith(function () {
    return "<h1>" + $(this).html() + "</h1>";
  });

  $('#Slideshow-template--14532439474310__slideshow .hero__title .animation-cropper div').replaceWith(function () {
    return "<h1 class='animation-contents'>" + $(this).html() + "</h1>";
  });
   $('.newsletter-section p.h3').replaceWith(function () {
    return "<h2 class='h3'>" + $(this).html() + "</h2>";
  });
});